 <!-- Banner principal -->
<app-product-list-hero></app-product-list-hero>

<main  class="container-lg my-3">
  <section *ngIf="!customerTypeIdNotFound; else customerNotFound">
    <h1 class="d-flex justify-content-center mb-3">Nuestro Catálogo</h1>
    <div class="products-container">
      <div class="card mb-3 rounded-3 overflow-hidden position-relative product-card" *ngFor="let product of dataSource" style="max-width: 540px;">
        <mat-icon
          class="position-absolute end-0 m-2"
          [hidden]="!hasTooltip(product.name)"
          [matTooltip]="getTooltipDescription(product.name)"
        >
          info
        </mat-icon>
        <div class="row g-0">
          <div class="col-md-4 img-container align-self-center h-100">
            <img src="{{product.principalImage}}" [alt]="product.name" class="img-fluid product-image rounded-start p-2">
          </div>
          <div class="col-md-8">
            <div class="card-body d-flex align-items-center align-items-md-start flex-column w-100">
              <h5 class="card-title w-100">{{product.name}}</h5>
              <p class="card-text w-100">
                <u [ngStyle]="{ 'text-decoration': hasShoppingDiscount ? 'line-through': 'none' }"  >{{product.itemPrices.price | currency }}</u>
                <span [hidden]="hasShoppingDiscount">
                  <ng-container *ngIf="product?.itemPrices?.tax == 0; else IVANotIncluded">
                    (IVA incluido)
                  </ng-container>
                  <ng-template #IVANotIncluded>
                    ({{product?.itemPrices?.tax * 100}}% IVA)
                  </ng-template>
                </span>
              </p>
              <ng-container *ngIf="hasShoppingDiscount">
                <p class="card-text w-100 text-danger mb-3">
                  {{product.itemPrices.priceWithDiscount | currency }}
                  <ng-container *ngIf="product.itemPrices.tax == 0; else IVANotIncluded">
                    (IVA incluido)
                  </ng-container>
                  <ng-template #IVANotIncluded>
                    ({{product?.itemPrices?.tax * 100}}% IVA)
                  </ng-template>
                </p>
              </ng-container>
              <p style="height:150px;" class="card-text w-100 overflow-auto mb-3">{{product.description}}</p>
              <button mat-button class="button secondary-button lh-1 py-1 px-4 detail-button mt-3 mt-md-auto" (click)="showDetails(product)">Ver más</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <ng-template #customerNotFound>
    <div class="w-75 py-5 h-100 d-flex flex-column justify-content-center align-items-center gap-4 mx-auto">
      <img class="mx-auto customer-not-found-img" src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-files/undraw/no-customer-id-found.png" alt="Notificación">
      <p class="msg">No tienes asignado un identificador de cliente</p>
    </div>
  </ng-template>
</main>

<!-- Footer con información de contacto -->
<app-product-list-contact-us></app-product-list-contact-us>
